/* unplugin-vue-components disabled */import { render } from "./pointtext.vue?vue&type=template&id=9505dca8&scoped=true"
import script from "./pointtext.vue?vue&type=script&lang=js"
export * from "./pointtext.vue?vue&type=script&lang=js"

import "./pointtext.vue?vue&type=style&index=0&id=9505dca8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9505dca8"]])

export default __exports__